import React from 'react'
import './Logs.css'
const Logs = ({mood, setAlert}) => {
  return (
    <div className='Logs'>
      Logs
    </div>
  )
}

export default Logs
